module.exports = __webpack_public_path__ + "static/media/twitter-link.80667314.svg";